
const ContactHero = () => {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0eb9f6243a002ebef590cd6e6f7a4698.jpg"
          alt="Connect With Us"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black"></div>
      </div>

      {/* X Pattern Overlay */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="xPatternContact" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
              <line x1="0" y1="0" x2="80" y2="80" stroke="#10B981" strokeWidth="1" />
              <line x1="80" y1="0" x2="0" y2="80" stroke="#10B981" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#xPatternContact)" />
        </svg>
      </div>

      {/* Floating X Elements */}
      <div className="absolute top-1/4 left-1/4 text-emerald-500/10 text-[250px] font-bold blur-sm">✕</div>
      <div className="absolute bottom-1/4 right-1/4 text-teal-500/10 text-[180px] font-bold blur-sm rotate-45">✕</div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <span className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full text-emerald-400 text-xs font-semibold uppercase tracking-widest mb-6">
          START THE CONVERSATION
        </span>
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-8 tracking-tight">
          Let's Identify Your <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">Crux.</span>
        </h1>
        <p className="text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto">
          If growth feels constrained or operations feel heavy, it's time to install intelligence where it actually matters.
        </p>
      </div>
    </section>
  );
};

export default ContactHero;
